import React from "react";

interface LogoutIconProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const LogoutIcon: React.FC<LogoutIconProps> = ({
  fill,
  onClick,
  width,
  height,
}) => {
  return (
    <svg
      width={width ?? "25"}
      height={height ?? "25"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M18.6667 19.8333L24.5 14M24.5 14L18.6667 8.16667M24.5 14H10.5M10.5 3.5H9.1C7.13982 3.5 6.15973 3.5 5.41103 3.88148C4.75247 4.21703 4.21703 4.75247 3.88148 5.41103C3.5 6.15972 3.5 7.13982 3.5 9.1V18.9C3.5 20.8602 3.5 21.8403 3.88148 22.589C4.21703 23.2475 4.75247 23.783 5.41103 24.1185C6.15972 24.5 7.13982 24.5 9.1 24.5H10.5"
        stroke="#FCFCFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogoutIcon;
